<template>
  <div class="animated fadeIn">
    <b-row>
      <!--
      <div>
  <b-card no-body>
    <b-tabs card>
      <b-tab title="Tab 1" active>
        <b-card-text>Tab Contents 1</b-card-text>
      </b-tab>
      <b-tab title="Tab 2">
        <b-card-text>Tab Contents 2</b-card-text>
      </b-tab>
    </b-tabs>
  </b-card>
</div>
      -->
      <b-col md="12">
        <b-card>
          <div class="form-group row">
            <label for="" class="col-lg-2 font-weight-bold">Branch</label>
            <div class="col-lg-6">
              <select name="tahun" id="branch" class="custom-select" v-model="branch" @change="onChange($event)">
                <option value="0">All</option>
                <template v-for="bran in branchs">
                  <option v-bind:value="bran.id.toString()" :key="bran.id">{{bran.name}}</option>
                </template>
              </select>
              <span class="text-danger" v-if="isSubmit && !branch">
                Please Select Branch
              </span>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-lg-2 font-weight-bold">Vendor</label>
            <div class="col-lg-6">
              <select name="tahun" id="vendor" class="custom-select" v-model="vendor">

                <template v-for="vendor in nameVendor">
                  <option v-bind:value="vendor.id">{{vendor.name}}</option>
                </template>
              </select>
              <span class="text-danger" v-if="isSubmit && !vendor">
                Please Select Vendor Active
              </span>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-lg-2 font-weight-bold">Periode</label>
            <div class="col-lg-6">
              <date-picker v-model="year" lang="en" format="YYYY" type="year"></date-picker>
            </div>
          </div>
          <div>
            <button class="btn btn-primary" @click="submit">Submit</button>
          </div>
          <br>
          <br>

          <b-row>
            <div class="table-responsive" v-if="submitData">
              <b-tabs
                active-nav-item-class="font-weight-bold text-uppercase text-success"
                active-tab-class="font-weight-bold text-success"
                content-class="mt-3"
              >
                <b-tab title="Summary" active>
                    <template v-if="noteVendor.length > 0">
                      <table class="table table-bordered table-note">
                        <thead>
                        <tr>
                          <th rowspan="2">No</th>
                          <th rowspan="2">Account Name</th>
                          <th rowspan="2">Alamat</th>
                          <th colspan="12" class="text-center">Downtime {{yearSelect}}</th>
                          <th rowspan="2" class="thead-grey">Total</th>
                        </tr>
                        <tr>
                          <th v-for="(month, i) in months" class="text-center">{{month}}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(value, j) in noteVendor">
                          <tr>
                            <td>{{j + 1}}</td>
                            <td>{{value[0].name}}</td>
                            <td>{{value[0].address}}</td>
                            <template v-for="(month, i) in months">
                              <td>
                                <a :href="value | hrefItem(i, yearSelect, vendorSelect, branch)">
                                  {{value | checkMonth(i)}}
                                </a>
                              </td>
                            </template>
                            <td >
                              <a :href="value | hrefYear(yearSelect, vendorSelect, branch)">{{value | totalDowntime}}</a>
                            </td>
                          </tr>
                        </template>
                        <!--<tr v-for="(value, name) in noteVendor">-->
                        <!--&lt;!&ndash;<show-row :name="name"></show-row>&ndash;&gt;-->
                        <!--&lt;!&ndash;<td>{{i+1}}</td>-->
                        <!--<td>{{note}}</td>-->
                        <!--<td>{{note.address}}</td>-->
                        <!--<td v-for="(month, index) in months">-->
                        <!--{{note.downtime | showMonth(index)}}-->
                        <!--</td>-->
                        <!--<td>{{note.downtime | totalDowntime}}</td>&ndash;&gt;-->
                        <!--</tr>-->
                        <tr>
                          <td colspan="3" align="center" class="bg-grey-total">Total
                            <span class="float-right"><strong>( {{noteVendor.length}} dari
                      <template v-if="totalCustomer.total">
                        {{totalCustomer.total}}
                      </template>
                        )
                      </strong></span>

                          </td>
                          <td v-for="(month, i) in months" class="bg-grey-total">
                            <a :href="i | hrefTotal(yearSelect, vendorSelect, branch)">
                              {{totalNote[i]}}
                            </a>
                          </td>
                          <td >
                            <a
                              :href="'/#/helpdesk/vendor/detail-downtime?id=all&date=' + yearSelect + '&vendor=' + vendorSelect +'&branch='+ branch + '&mode=all'">
                              {{totalNote| totalDownTimeAll }}
                            </a>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                    </template>
                    <template v-else>
                      <div class="alert alert-warning">
                        DownTime not Available
                      </div>
                    </template>

                </b-tab>
                <b-tab title="Total" >
                  <template  v-if="submitData">
                    <b-row>
                      <b-col md="10">
                        <chart-total-customer
                          :data="dataSet"
                          :width="1000"
                          :height="350"
                        />
                      </b-col>
                      <b-col md-2>
                        <a
                          :href="'/#/helpdesk/vendor/detail-downtime?id=all&date=' + yearSelect + '&vendor=' + vendorSelect +'&branch='+ branch + '&mode=detail'">
                          Detail&nbsp;<i class="fa fa-arrow-right"></i>
                        </a>
                        <br>
                        <table class="table table-striped" style="max-width: 350px" v-if="totalCustomer">
                          <tr>
                            <td>
                              <span class="dot" v-bind:style="{background: '#ff0000'}"></span>
                              Total Account</td>
                            <td> : </td>
                            <td align="right">{{totalCustomer.total}}</td>
                          </tr>
                          <tr>
                            <td>
                              <span class="dot" v-bind:style="{background: '#ccc'}"></span>
                              Total Account Down</td>
                            <td> : </td>
                            <td align="right">{{noteVendor.length}}</td>
                          </tr>
                          <tr>
                            <td>
                              <span class="dot" v-bind:style="{background: '#0000ff'}"></span>
                              Total Active</td>
                            <td> : </td>
                            <td align="right">{{totalCustomer.total_active}}</td>
                          </tr>
                          <tr>
                            <td>
                              <span class="dot" v-bind:style="{background: '#008000'}"></span>
                              Total Register</td>
                            <td> : </td>
                            <td align="right">{{totalCustomer.total_reg_on_periode}}</td>
                          </tr>
                          <tr>
                            <td>
                              <span class="dot" v-bind:style="{background: '#ffff00'}"></span>
                              Total Non Active</td>
                            <td> : </td>
                            <td align="right">{{totalCustomer.total_non_active}}</td>
                          </tr>
                          <tr>
                            <td>
                              <span class="dot" v-bind:style="{background: '#8d1673'}"></span>
                              Total Close</td>
                            <td> : </td>
                            <td align="right">{{totalCustomer.total_close_on_periode}}</td>
                          </tr>
                        </table>
                      </b-col>
                    </b-row>

                  </template>
                  <br>
                  <div>

                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>
<script>
  import data from '@/component/data'
  import {getService} from "../../services";
  import DatePicker from 'vue2-datepicker'
  import moment from 'moment'
  import ChartTotalCustomer from './ChartTotalCustomer'

  export default {
    components: {
      DatePicker,
      ChartTotalCustomer
    },
    data() {
      return {
        months: data.month3Letter,
        noteVendor: [],
        nameVendor: [],
        branchs: [],
        branch: '',
        vendor: '',
        vendorSelect: '',
        year: moment(),
        yearSelect: '',
        submitData: false,
        totalCustomer: {},
        totalNote: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        loaded: false,
        dataSet: [],
        dataHelp: [],
        isSubmit: false,
        // chartdata: {
        //   label: ['Total Account', 'Total Account Down', 'Total Active', 'Total Register', 'Total Non Active', 'Total Unregister'],
        //   datasets: []
        // },
        options: {
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    created: function () {
      // this.getListNoteVendor()
      this.getBranch()
      var that = this
      if (this.$store.getters.branchInVendor) {
        this.branch = this.$store.getters.branchInVendor
        this.getNameVendor(this.branch)
      } else {
        this.checkBranch = setInterval(() => {
          that.branch = that.$store.getters.branch
          if (that.branch) {
            clearInterval(that.checkBranch)
            this.getNameVendor(that.branch)
          }
        }, 1000);
      }
      if (this.$store.getters.vendorSelect) {
        this.vendor = this.$store.getters.vendorSelect
        this.vendorSelect = this.vendor
        this.year = this.$store.getters.yearInVendor
        this.yearSelect = moment(this.year).format('YYYY')
      }
      if (this.$store.getters.listCustomerVendor.length > 0) {
        this.submitData = true
        this.noteVendor = this.$store.getters.listCustomerVendor
      }
      if (this.$store.getters.totalListCustomerVendor.length > 0) {
        this.totalNote = this.$store.getters.totalListCustomerVendor
        this.totalCustomer = this.$store.getters.totalCustomer
        this.dataSet = this.$store.getters.dataGrafikAccount
      }
    },
    methods: {
      getNameVendor(branch) {
        getService.list_vendor_with_branch(branch)
          .then(
            data => {
              this.nameVendor = data
              // console.log(data)
            }
          )
      },
      submit() {
        this.isSubmit = true
        if (!this.branch || !this.vendor) {
          window.scrollTo(0, 0)
          return false
        }
        this.$store.commit('changeSelectVendor', this.vendor)
        this.$store.commit('changeBranchinVendorCustomer', this.branch)
        this.$store.commit('changeYearInVendor', this.year)
        this.vendorSelect = this.vendor
        this.dataSet = []
        this.dataHelp = []
        this.yearSelect = moment(this.year).format('YYYY')
        this.getListNoteVendor(this.vendorSelect, this.yearSelect, this.branch)
        this.getTotalCustomerInVendor(this.vendorSelect, this.yearSelect, '', this.branch)
      },
      getListNoteVendor(vendor, year, branch) {
        this.$store.commit('noLoad', true)
        getService.list_note_vendor(vendor, year, branch)
          .then(
            data => {
              // console.log(data)
              let totalNote = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
              this.submitData = true
              this.loaded = true
              this.$store.commit('noLoad', false)
              let dataNote = []
              let dataNotes = []
              let month;
              for (let i in data) {
                if (data.hasOwnProperty(i)) {
                  month = (moment(i, 'YYYY-MM').format('M')) - 1

                  let row = data[i]
                  for (let j in row) {
                    totalNote[month] += row[j].count
                    if (row.hasOwnProperty(j)) {
                      const help = {
                        'id': j,
                        'month': month,
                        'count': row[j].count,
                        'name': row[j].cust_acc_name,
                        'address': row[j].installation_address
                      }
                      if (dataNote['s' + j]) {
                        dataNote['s' + j].push(help)
                      } else {
                        dataNote['s' + j] = [];
                        dataNote['s' + j].push(help)
                      }
                    }
                  }
                }
              }
              // this.noteVendor = data

              for (let i in dataNote) {
                if (dataNote.hasOwnProperty(i)) {
                  dataNotes.push(dataNote[i])
                }
              }
              this.noteVendor = dataNotes
              this.totalNote = totalNote
              this.$store.commit('changeListCustomerVendor', dataNotes)
              this.$store.commit('changeTotalListCustomerVendor', totalNote)
              // console.log(dataNotes)
              // const dataset = {
              //   label: 'Total Account Down',
              //   backgroundColor: '#a00991',
              //   data: [this.noteVendor.length]
              // }
              // this.chartdata.datasets.push(dataset)
              this.checkdata(this.noteVendor.length)
            }
          )
      },
      checkdata(data) {
        setTimeout(() => {
          if(this.dataHelp.length == 0) {
            this.checkdata(data)
          } else {
            this.dataSet = [...this.dataHelp, data]
            this.$store.commit('changeDataGrafik', this.dataSet)
          }
        }, 1000)
      },
      async getTotalCustomerInVendor(vendor, year, month, branch) {
        try {
          await getService.list_vendor_total(vendor, year, month, branch)
            .then( data=> {
              this.totalCustomer = data
              this.$store.commit('changeTotalCustomer', this.totalCustomer)
              // this.chartdata.datasets.push(this.createDataSet('Total Account', '#ff0000', data.total))
              // this.chartdata.datasets.push(this.createDataSet('Total Active', '#0000ff', data.total_active))
              // this.chartdata.datasets.push(this.createDataSet('Total Register', '#008000', data.total_reg_on_periode))
              // this.chartdata.datasets.push(this.createDataSet('Total Non Active', '#ffff00', data.total_non_active))
              // this.chartdata.datasets.push(this.createDataSet('Total Unregister ', '#8d1673', data.total_close_on_periode))
              this.dataHelp.push(data.total)
              this.dataHelp.push(data.total_active)
              this.dataHelp.push(data.total_reg_on_periode)
              this.dataHelp.push(data.total_non_active)
              this.dataHelp.push(data.total_close_on_periode)
            })
        } catch (error) {

        }
      },
      createDataSet(label, color, data) {
        const dataset = {
          label: label,
          backgroundColor: color,
          data: [data]
        }
        return dataset
      },
      async getBranch() {
        try {
          await getService.list_branch()
            .then(data => {
              this.branchs = data
            })
        } catch (error) {
          // bila data tidak terpanggil
        }
      },
      onChange(event) {
        let branch = event.target.value
        this.getNameVendor(branch)
      }
    },
    filters: {
      checkMonth(downtime, index) {
        for (let i = 0; i < downtime.length; i++) {
          if (downtime[i].month == index) {
            return downtime[i].count
          } else if (downtime[downtime.length - 1] < i) {
            return ''
          }
        }
        return ''
      },
      totalDowntime(downtime) {
        let total = 0;
        for (let i = 0; i < downtime.length; i++) {
          total = total + downtime[i].count
        }
        return total
      },
      hrefItem(item, index, date, vendor, branch) {
        for (let i in item) {
          if (item.hasOwnProperty(i)) {
            if (item[i].month == index) {
              var id = item[i].id

              var month = Number(item[i].month) + 1 < 9 ? '0' + (Number(item[i].month) + 1) : Number(item[i].month) + 1
              var date = date + '-' + month
              return '#/helpdesk/vendor/detail-downtime?id=' + id +
                '&date=' + date +
                '&vendor=' + vendor +
                '&branch=' + branch
            }
          }
        }
      },
      hrefYear(item, year, vendor, branch) {
        for (let i in item) {
          if (item.hasOwnProperty(i)) {
            var id = item[i].id
            return '#/helpdesk/vendor/detail-downtime?id=' + id +
              '&date=' + year +
              '&vendor=' + vendor +
              '&branch=' + branch
          }
        }
      },
      hrefTotal(i, year, vendor, branch) {
        var day = (Number(i) + 1) < 9 ? '0' + (Number(i) + 1) : Number(i) + 1
        var date = year + '-' + day
        return '#/helpdesk/vendor/detail-downtime?id=all' +
          '&date=' + date +
          '&vendor=' + vendor +
          '&branch=' + branch
      },
      totalDownTimeAll(downtime) {
        let total = 0
        for (let i = 0; i < downtime.length; i++) {
          total += downtime[i]
        }
        return total
      },
      changeTime(time) {
        var d = Number(item[i].total)
        var h = Math.floor(d / 3600)
        var m = Math.floor(d % 3600 / 60)
        var s = Math.floor(d % 3600 % 60)

        var hDisplay = h > 9 ? h + " jam " : '0' + h + ' jam '
        var mDisplay = m > 9 ? m + "menit " : '0' + m + " menit "

        return hDisplay + mDisplay;
      }
    }

  }
</script>

<style>
  table.table-note>tbody>tr>td:last-child,
  table.table-note>tbody>tr:last-child>td
  {
    background-color: #e9ebec;
    font-weight: bold;
    text-align: center;

  }

  .thead-grey{
    background-color: #e9ebec;
    font-weight: bold;
  }
</style>
